import { createContext } from 'react'

export interface MultiStepFormContextValues {
  stepLabels: readonly string[]
  activeStepIndex: number
  handleOnClickNextStep: () => void
  handleOnClickPrevStep: () => void
  handleResetForm?: () => void
}

export const MultiStepFormContext = createContext<MultiStepFormContextValues>({} as MultiStepFormContextValues)
